// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch_switch__1Gap2","container":"switch_container__2J-7v","label":"switch_label__ERE8u"};